const state = {
    TextVwelcome: "",
    Shootingbook:[],
    ShootingbookApproval:[],
    TodayMember:[],
    TodaySA:[],
    TodaySL:[],
    ClubMember:[],
    VerbandAll:[],
    VerbandOwn:[],
    ShootingRanges:[],
    Weapons:[],
    Terminals:[],
    WorkingHours:[],
    client_terminal_telemetries:[],
    client_terminal_rfid_logs:[],
    WeaponPool: [],
    WeaponPoolStatistics: null,
    WeaponPoolShowOnlyActive: false,
    // Arbeitsstunden Feature
    ArbeitsstundenAuswertung: [],
    ArbeitsstundenFreigaben: [],
    Arbeitseinsaetze: [],
    Beitragsgruppen: [],
    BeitragsgruppeMembers: [],
    ArbeitsstundenFunctions: [],
    ArbeitseinsatzTeilnehmer: []
};

export default state;
